const DEFAULT_CONCURRENCY = 2;

/**
 * Process import IDs with a fixed concurrency limit so large migrations do not freeze the browser.
 */
export async function runBatchParseQueue(
  ids: string[],
  parseOne: (id: string) => Promise<void>,
  options?: { concurrency?: number; onStart?: (id: string) => void },
): Promise<void> {
  if (ids.length === 0) return;

  const concurrency = Math.max(1, options?.concurrency ?? DEFAULT_CONCURRENCY);
  let cursor = 0;

  async function worker() {
    while (cursor < ids.length) {
      const index = cursor;
      cursor += 1;
      const id = ids[index]!;
      options?.onStart?.(id);
      try {
        await parseOne(id);
      } catch {
        // Individual item errors are recorded by parseOne; continue the batch.
      }
    }
  }

  await Promise.all(Array.from({ length: Math.min(concurrency, ids.length) }, () => worker()));
}
